/** G4 五屏共用的分区取数包装：501 显示「接口未提供：<路径>」+ 后端 detail（不当错误、不当空），其余同 ScreenState。 */

import type { ReactNode } from "react";

import { notProvided } from "../../api/g4";
import type { ReadResult } from "../../api/queries";
import { Note } from "../../components/Card";
import { Pill } from "../../components/Pill";
import { ScreenState } from "../p2/Common";

export function Section<T>({
  query,
  what,
  path,
  missing,
  children,
}: {
  query: ReadResult<T>;
  what: string;
  path: string;
  /** 501 时额外说明（如「结论列标缺」）。 */
  missing?: ReactNode;
  children: (data: T) => ReactNode;
}): ReactNode {
  const gap = query.status === "error" ? notProvided(query.error) : null;
  if (gap) {
    return (
      <Note tone="warn">
        接口未提供：<code>{path}</code>（{gap.detail}）{missing ? <> · {missing}</> : null}
      </Note>
    );
  }
  return (
    <ScreenState query={query} what={what}>
      {children}
    </ScreenState>
  );
}

/** 值缺失（后端给 null / 字段未提供）时统一标「缺」，不写成 0 或「无」。 */
export function Missing(): ReactNode {
  return <Pill tone="warn">缺</Pill>;
}
